export default "__VITE_ASSET__d1b77cdd__"